module.exports = __webpack_public_path__ + "static/media/DeletedraftIcon.51dcb515.svg";